import { FC, useRef } from "react";
import { useDispatch } from "react-redux";

import { prevStep, nextStep } from "../../../store/reducers/paymentRequestLink";
import { Button, Icon } from "../../../components/common";
import { IntercomObserver } from "../../../components/observers";
import { PayerDataForm } from "../PayerDataForm";

export const PayerData: FC = () => {
  const actionContainerRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();

  const onClickBack = () => dispatch(prevStep());
  const onClickContinue = () => dispatch(nextStep());

  return (
    <div className="flex flex-col justify-between h-screen w-screen md:items-center">
      <div className="md:w-1/2">
        <div className="flex flex-col px-4 gap-4">
          <div className="flex pt-2">
            <Button
              className="p-0"
              icon
              onClick={onClickBack}
              variant={Button.variant.TERTIARY}
              size={Button.size.SMALL}
            >
              <Icon icon="Arrow-left" size={24} className="white" />
            </Button>
          </div>

          <div>
            <h4 className="font-poppins font-bold text-2xl">
              Payer Information
            </h4>

            <div>Please provide your details.</div>
          </div>

          <div>
            <PayerDataForm callback={onClickContinue} />
          </div>
        </div>

        <IntercomObserver footer={actionContainerRef} />
      </div>
    </div>
  );
};
